import DatabaseManager from "../core/DatabaseManager";

class AppDatabase extends DatabaseManager {
  constructor() {
    super("gi-mobile", 1);
    this.setupStores();
  }

  setupStores() {
    // User Table
    this.registerStore("user", {
      keyPath: "id",
      indexes: [
        { name: "email", keyPath: "email", unique: true },
        { name: "active", keyPath: "active" },
      ],
    });

    // Project Table
    this.registerStore("project", {
      keyPath: "id",
      indexes: [
        { name: "owner_id", keyPath: "owner_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // Member Table
    this.registerStore("member", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "user_id", keyPath: "user_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // LOCA (Drillhole) Table
    this.registerStore("LOCA", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_ID", keyPath: "LOCA_ID" },
        { name: "active", keyPath: "active" },
      ],
    });

    // HDPH (Depth Related Exploratory Hole Info) Table
    this.registerStore("HDPH", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // HORN (Hole Orientation Inclination) Table
    this.registerStore("HORN", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // FLSH (Drilling Flush) Table
    this.registerStore("FLSH", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // PTIM (Progress By Time) Table
    this.registerStore("PTIM", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // CDIA (Casing Diameter) Table
    this.registerStore("CDIA", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // SAMP (Sampling) Table
    this.registerStore("SAMP", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // ISPT (Standard Penetration) Table
    this.registerStore("ISPT", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // IVAN (Vane Shear) Table
    this.registerStore("IVAN", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // IPRG (Permeability Test) Table
    this.registerStore("IPRG", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // PMTG (Pressuremeter Test) Table
    this.registerStore("PMTG", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // Televiewer Survey Table
    this.registerStore("televiewer_survey", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // Impression Packer Table
    this.registerStore("impression_packer", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // MONG (Installation) Table
    this.registerStore("MONG", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // CORE (Coring) Table
    this.registerStore("CORE", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // FRAC (Fracture Spacing) Table
    this.registerStore("FRAC", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // GEOL (Geological Info) Table
    this.registerStore("GEOL", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "LOCA_id", keyPath: "LOCA_id" },
        { name: "active", keyPath: "active" },
      ],
    });

    // Image Operation Table
    this.registerStore("image_operation", {
      keyPath: "id",
      indexes: [
        { name: "project_id", keyPath: "project_id" },
        { name: "reference_id", keyPath: "reference_id" },
        { name: "active", keyPath: "active" },
      ],
    });
  }

  async resetDatabase() {
    try {
      if (this.db) {
        this.db.close();
      }
      await this.deleteDatabase();
      await this.initDatabase();
      console.log("Database reset successfully");
    } catch (error) {
      console.error("Failed to reset database:", error);
      throw error;
    }
  }
}

export const appDatabase = new AppDatabase();

export const initialize = async () => {
  try {
    await appDatabase.initDatabase();
    console.log("Database initialized successfully");
  } catch (error) {
    console.error("Database initialization failed:", error);
    throw error;
  }
};

export const resetDatabase = async () => {
  try {
    await appDatabase.resetDatabase();
  } catch (error) {
    console.error("Database reset failed:", error);
    throw error;
  }
};
